const VERIFIED_ACCOUNT_STORAGE_PREFIX = "lea_tink_verified_account";

const buildStorageKey = (flowId: string): string =>
	`${VERIFIED_ACCOUNT_STORAGE_PREFIX}:${flowId}`;

export const storeTinkVerifiedAccountNumber = (
	flowId: string,
	accountNumber: string
): void => {
	if (typeof window === "undefined") return;

	const normalized = accountNumber.trim();
	if (!normalized) return;

	sessionStorage.setItem(buildStorageKey(flowId), normalized);
};

export const consumeTinkVerifiedAccountNumber = (
	flowId: string
): string | undefined => {
	if (typeof window === "undefined") return undefined;

	const key = buildStorageKey(flowId);
	const value = sessionStorage.getItem(key)?.trim();
	if (!value) return undefined;

	sessionStorage.removeItem(key);
	return value;
};
